import { render, staticRenderFns } from "./ModalRemover.vue?vue&type=template&id=1b9c8b16&"
import script from "./ModalRemover.vue?vue&type=script&lang=js&"
export * from "./ModalRemover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports